import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { SalesOrderCrudService } from 'src/app/shared/services/sales-order-crud.service';
import { SalesOrder } from 'src/app/shared/interfaces/sales-order';
import { Harvest } from '../shared/interfaces/harvest';
import { HarvestCrudService } from '../shared/services/harvest-crud.service';


@Component({
  selector: 'app-sales-orders',
  templateUrl: './sales-orders.component.html',
  styleUrls: ['./sales-orders.component.scss']
})
export class SalesOrdersComponent implements OnInit {

  salesOrders: SalesOrder[];
  salesOrder: SalesOrder;
  selectedSalesOrders: SalesOrder[] = [];

  harvests: Partial<Harvest>[];
  harvestNames: string[];
  harvestsMap : Map<string,Harvest>;


  salesOrderDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private salesOrderService : SalesOrderCrudService,
    private harvestService : HarvestCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Sales Orders'}
    ];

    this.salesOrders = [];
    this.salesOrder = { } as SalesOrder ;

    this.harvests = [];
    this.harvestNames = [];
    this.harvestsMap = new Map<string,Harvest>();
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.salesOrderService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.salesOrders = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : SalesOrder = jsonItem as SalesOrder;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.salesOrders.push(l);
        }
      })
    });

    let h = this.harvestService.getList(); 
    h.snapshotChanges().subscribe(data => {
      this.harvests = [];
      this.harvestNames = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Harvest = jsonItem as Harvest;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          //l.code = l.name;
          let ll : Partial<Harvest> = l;
          delete ll.$key;
         // if (l.isEnabled ) {
            this.harvests.push(ll);
            this.harvestNames.push(l.name);
         // }
          this.harvestsMap.set(l.key || 'na' , l);
        }
      });
     // console.log(this.grapeVarieties);
     this.harvests = this.harvests.sort((a, b) => ( (a.position || 0) < (b.position || 1) ) ? -1 : 1);
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Notes' },
      { field: 'tags', header: 'Tags' },

     // { field: 'salesOrderedOrderKey', header: 'Harvest' },
      { field: 'salesOrderedOrderName', header: 'Order' },
      { field: 'salesOrderedAt', header: 'At' },
      { field: 'salesOrderedBy', header: 'By' },
      { field: 'itemTypeName', header: 'Content' },
      { field: 'itemNumber', header: 'Number' },

      // { field: 'harvestName', header: 'Harvest' },
      // { field: 'fishAverageWeight', header: 'Weight (avg)' },
      // { field: 'fishNumber', header: 'Fish (nb)' },
      // { field: 'fishMortality', header: 'Mortality (nb / %)' },
      // { field: 'filledAt', header: 'Filled at' },
      // { field: 'emptiedAt', header: 'Emptied at' },

      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'tags');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.salesOrderService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.salesOrders);
            doc.save('salesOrders.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.salesOrders);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "salesOrders");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedSalesOrders);
      // console.log('SAVEC CSV LOCATIONS ', this.salesOrders);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedSalesOrders, 'salesOrders', exportCols);
   // this.exportService.exportToCsv(this.salesOrders, 'salesOrders', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.salesOrder = {} as SalesOrder;
    this.submitted = false;
    this.salesOrderDialog = true;
  }

  deleteSelectedSalesOrders() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected salesOrders?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.salesOrders = this.salesOrders.filter(val => !this.selectedSalesOrders.includes(val));
            
            this.selectedSalesOrders.forEach( salesOrder => this.salesOrderService.delete(salesOrder.$key));
            this.selectedSalesOrders = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'SalesOrderss Deleted', life: 3000});
        }
    });
  }

  editSalesOrder(salesOrder: SalesOrder) {
    this.salesOrder = {...salesOrder};
    this.salesOrderDialog = true;
  }

  deleteSalesOrder(salesOrder: SalesOrder) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + salesOrder.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.salesOrders = this.salesOrders.filter(val => val.$key !== salesOrder.$key);
            this.salesOrder = {} as SalesOrder;
            this.salesOrderService.delete(salesOrder.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'SalesOrder Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.salesOrderDialog = false;
    this.submitted = false;
  }

  saveSalesOrder() {
    this.submitted = true;

    if ( this.salesOrder.name.trim() ) {
      if (this.salesOrder.$key) {
          this.salesOrders[this.findIndexById(this.salesOrder.$key)] = this.salesOrder;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'SalesOrder Updated', life: 3000});
          this.salesOrderService.update(this.salesOrder);
        } else {
          this.salesOrder.position = this.salesOrders.length;
          this.salesOrderService.add(this.salesOrder);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'SalesOrder Created', life: 3000});
      this.salesOrders = [...this.salesOrders];
    }

    this.salesOrderDialog = false;
    this.salesOrder = { } as SalesOrder;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.salesOrders.length; i++) {
        if (this.salesOrders[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeSalesOrder(salesOrder : SalesOrder) {
    this.salesOrderService.update(salesOrder);
  }

  completePosition(salesOrder : SalesOrder) {
    if ( this.newPosition > -1 ) {
        salesOrder.position = this.newPosition;
        salesOrder = this.checkPositionLimits(salesOrder);
        this.reorderElements(salesOrder);
        //this.updateDB(salesOrder);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.salesOrders);
    // const myClonedArray = [];
    // this.salesOrders.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.salesOrders.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.salesOrders.length - 1 - event.dropIndex;
    const salesOrderToMove = this.salesOrders[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.salesOrders[index] = this.salesOrders[index+1];
        this.salesOrders[index].position = index;
        this.salesOrderService.update(this.salesOrders[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.salesOrders[index] = this.salesOrders[index-1];
        this.salesOrders[index].position = index;
        this.salesOrderService.update(this.salesOrders[index]);
      }
    } 
    this.salesOrders[endIndex] = salesOrderToMove;
    this.salesOrders[endIndex].position = endIndex;
    this.salesOrderService.update(this.salesOrders[endIndex]);
  }

  // onFieldEdit(salesOrder: Spray, fieldName: string): void {
  //   //console.log(this.salesOrders);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + salesOrder[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       salesOrder.position = this.newPosition;
  //       salesOrder = this.checkPositionLimits(salesOrder);
  //       this.reorderElements(salesOrder);
  //       //this.updateDB(salesOrder);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(salesOrder);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.salesOrders.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, salesOrder: SalesOrder) {
    // console.log("event" +event);
    if (salesOrder.position != null && salesOrder.position > -1) {
      this.previousPosition = salesOrder.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(salesOrder: SalesOrder) {
    console.log('check ',salesOrder.position + ' ' + this.salesOrders.length);
    if (!salesOrder.position) {
     // console.log('check 1');
      return this.salesOrder;
    }
    if (salesOrder.position < 0) {
      salesOrder.position = 0;
      // console.log('check 2');
      return salesOrder;
    }
    if (salesOrder.position > this.salesOrders.length) {
      salesOrder.position = this.salesOrders.length - 1;
    //  console.log('check 3', salesOrder.position);
      return salesOrder;
    }
   // console.log('check 4');
    return salesOrder;
  }

  async reorderElements(salesOrder: SalesOrder) {
    this.newPosition = this.newPosition  > this.salesOrders.length ? this.salesOrders.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === salesOrder.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const salesOrderToMove = this.salesOrders[startIndex];
   // console.log('Item to move: ', this.salesOrders[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.salesOrders);
        console.log('Item to +1: ', this.salesOrders[index+1]);

        this.salesOrders[index] = this.salesOrders[index+1];
        this.salesOrders[index].position = index;
        // console.log('Move: ', this.salesOrders[index+1]);
        // console.log('Move pos: ', this.salesOrders[index].position);
        //await this.updateDB(this.salesOrders[index]);
        this.salesOrderService.update(this.salesOrders[index]);
     //   console.log('Update DB: ', this.salesOrders[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.salesOrders[index] = this.salesOrders[index-1];
        this.salesOrders[index].position = index;
        this.salesOrderService.update(this.salesOrders[index]);
      }
    } 
    this.salesOrders[endIndex] = salesOrderToMove;
    this.salesOrders[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.salesOrderService.update(this.salesOrders[endIndex]);
    
    // const myClonedArray = [];
    // this.salesOrders.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.salesOrders = myClonedArray;
   // this.getAllRecords();
  }


  onSelect (event: any, salesOrder: SalesOrder) {
    //this.completeBarrel(barrel);
  }

  onBlur(event: any, salesOrder: SalesOrder) {
    this.completeSalesOrder(salesOrder);
  }

  onClose(event: any, salesOrder: SalesOrder) {
    this.completeSalesOrder(salesOrder);
  }


  onChangeHarvest(salesOrder: SalesOrder, salesOrderHarvestKey: string, event: any): boolean {

    // console.log('barrel event', event);
    // console.log('be ', event);

    const newKey = event.value;
    const previousKey = salesOrderHarvestKey;
    console.log('new key wanted',  newKey);
    console.log('before key ', previousKey);

    // Si il n'y en avait pas avant et ni maintenant, riemn a faire
    if (!previousKey && !newKey) {
      return true;
    }

    // Si le barril est le meme rien a faire
    if (previousKey && newKey && previousKey == newKey) {
      return true;
    }


    // Sil il n'y avait pas de barril avant et maintenant oui
    // if (!previousKey && newKey) {

    //   const newHarvest = this.harvestsMap.get(newKey) || {} as Harvest;
    //   const newHarvestName = newHarvest.name;
        
    //   salesOrder.harvestKey = newKey;
    //   salesOrder.harvestName = newHarvestName;
    //   this.salesOrderService.update(salesOrder);
    //   return true;

    // }

    // if (previousKey && !newKey) {
    //   salesOrder.harvestKey = '';
    //   salesOrder.harvestName = '';
    //   this.salesOrderService.update(salesOrder);
    //   return true;
    // }

    // const newRegion = this.harvestsMap.get(newKey) || {} as Harvest;
    // const newHarvestName = newRegion.name;
        
    // salesOrder.harvestKey = newKey;
    // salesOrder.harvestName = newHarvestName;
    this.salesOrderService.update(salesOrder);
    return true;
  }

  displayHarvestName(key : string): string {
    if (this.harvestsMap.has(key)) {
      return this.harvestsMap.get(key)?.name || '';
    }
    return '';
  }

}
